export const UNIT = 8;

export const QUERY_MOBILE = '@media (min-width: 701px)';
export const QUERY_LARGE_MOBILE = '@media (min-width: 901px)';



// WEBPACK FOOTER //
// ../src/client/styles/layout.js